export default __webpack_public_path__ + "5b23e125bc59748aa6c290b27a7cd1f9.svg";